import { render, staticRenderFns } from "./DolarSpotGraph.vue?vue&type=template&id=44fa8f9e&"
import script from "./DolarSpotGraph.vue?vue&type=script&lang=js&"
export * from "./DolarSpotGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\LrGithub\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44fa8f9e')) {
      api.createRecord('44fa8f9e', component.options)
    } else {
      api.reload('44fa8f9e', component.options)
    }
    module.hot.accept("./DolarSpotGraph.vue?vue&type=template&id=44fa8f9e&", function () {
      api.rerender('44fa8f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/dolar-spot-graph/DolarSpotGraph.vue"
export default component.exports